// src/utils/vpnPrivacy.js — centralized VPN / privacy helpers (read-only)

function toMillisSafe(expiresAt) {
  if (!expiresAt) return 0;
  if (typeof expiresAt.toMillis === "function") {
    const ms = expiresAt.toMillis();
    return typeof ms === "number" && Number.isFinite(ms) ? ms : 0;
  }
  if (typeof expiresAt === "number" && Number.isFinite(expiresAt)) {
    return expiresAt;
  }
  return 0;
}

function str(v) {
  if (v == null) return "";
  const s = String(v).trim();
  return s;
}

/**
 * @param {object | null | undefined} user
 * @returns {boolean}
 */
export function isPremiumActive(user) {
  if (!user) return false;
  const prem = user.premium || {};
  if (prem.active !== true) return false;
  const expMs = toMillisSafe(prem.expiresAt);
  return expMs > Date.now();
}

/**
 * @param {object | null | undefined} user
 * @returns {boolean}
 */
export function canSeeReadReceipts(user) {
  if (!isPremiumActive(user)) return false;
  return user?.settings?.messages?.vpnReadReceipts === true;
}

/**
 * @param {object | null | undefined} user
 * @returns {boolean}
 */
export function shouldHidePresence(user) {
  if (!isPremiumActive(user)) return false;
  return user?.settings?.messages?.vpnShowOnline === false;
}

/**
 * @param {object | null | undefined} user
 * @returns {boolean}
 */
export function shouldUseVpnCountry(user) {
  if (!isPremiumActive(user)) return false;
  return user?.settings?.messages?.vpnVisibleCountry === true;
}

/**
 * @param {object | null | undefined} user
 * @returns {string}
 */
export function getVisibleCountry(user) {
  if (!user) return "";
  if (shouldUseVpnCountry(user)) {
    const prem = user.premium || {};
    return (
      str(prem.country) ||
      str(user.displayCountry) ||
      str(user.countryKey) ||
      str(user.country) ||
      ""
    );
  }
  return (
    str(user.realCountry) ||
    str(user.countryKey) ||
    str(user.country) ||
    ""
  );
}
